import React from "react";
import Layout from "../Layout";
import WorkScheduleManagement from "../../../widgets/management/work-schedule/WorkSchedule";

function WorkSchedule(props) {
  return (
    <Layout>
      <WorkScheduleManagement />
    </Layout>
  );
}

export default WorkSchedule;
